import { useEffect, useState } from 'react';
import { SEOHead } from '../../../components/seo/SEOHead';
import { DataTable } from '../../../components/admin/DataTable';
import { Spinner } from '../../../components/ui/Card';
import { api } from '../../../lib/api';

interface PaymentRow {
  id: string;
  amount: number;
  status: string;
  gateway_payment_id: string | null;
  order_number: string;
  contact_name: string;
  created_at: string;
}

export default function PaymentList() {
  const [payments, setPayments] = useState<PaymentRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api.admin.payments
      .list()
      .then((res) => setPayments(res.items as PaymentRow[]))
      .catch(() => setPayments([]))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <SEOHead title="Payments — Admin" description="" canonicalPath="/admin/payments" />

      <h1 className="font-display text-2xl font-bold text-ink">Payments</h1>

      <div className="mt-4">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : (
          <DataTable
            columns={[
              { header: 'Order #', render: (p) => <span className="font-mono text-xs">{p.order_number}</span> },
              { header: 'Customer', render: (p) => p.contact_name },
              { header: 'Amount', render: (p) => `₹${p.amount.toLocaleString('en-IN')}` },
              {
                header: 'Status',
                render: (p) => (
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-xs ${
                      p.status === 'captured' ? 'bg-ledger-green/10 text-ledger-green' : 'bg-ink/5 text-ink/60'
                    }`}
                  >
                    {p.status}
                  </span>
                ),
              },
              { header: 'Date', render: (p) => new Date(p.created_at).toLocaleDateString('en-IN') },
            ]}
            rows={payments}
            keyExtractor={(p) => p.id}
            emptyMessage="No payments yet."
          />
        )}
      </div>
    </>
  );
}
